import React from 'react'
import Icon1 from '@app/assets/images/Group51.svg'
import Icon2 from '@app/assets/images/Group52.svg'
import Icon3 from '@app/assets/images/Group53.svg'
import Icon4 from '@app/assets/images/Group54.svg'
import Icon5 from '@app/assets/images/Group55.svg'
import Icon6 from '@app/assets/images/Group56.svg'
import Icon7 from '@app/assets/images/Group57.svg'
import Icon9 from '@app/assets/images/Group59.svg'
import './manager-main-page.less'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@app/store/store'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import axios from 'axios'
import employeeRepository from '@app/api/repositories/employee-repository'
import { getOrganization } from '@app/store/actions/organization-actions'
import { capitalizeName } from '@app/utils/capitalize/capitalize'
import { Image } from 'antd'
import { host } from '@app/constants/env'
import { useState } from 'react'
import { getFile } from '@app/store/actions/files-actions'
import { Link } from 'react-router-dom'

const ManagerMainPage: React.FC = () => {
  const organization = useSelector(
    (state: RootState) => state.organizations.organization,
  )
  const user = useSelector((state: RootState) => state.userInfo.userInfo)
  const { photo } = useSelector((state: RootState) => state.files)
  const [t] = useTranslation()
  const dispatch = useDispatch()
  const [employees, setEmployees] = useState<any>()

  useEffect(() => {
    const source = axios.CancelToken.source()
    dispatch(
      getOrganization(
        { data: user.organizations[0].organizationId, source },
        t('organization.error'),
      ),
    )
    employeeRepository
      .getEmployeePositions({
        params: `organizationId.equals=${user.organizations[0].organizationId}&employeePositionDictionaryId.in=40`,
      })
      .then((res) => setEmployees(res.data))
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [])

  useEffect(() => {
    const source = axios.CancelToken.source()
    const employee = employees?.find(
      (employee) =>
        employee.status.type === 'WORKING' && employee.position.id === 40,
    )
    if (employee && employee.employee.fileId) {
      dispatch(getFile({ data: employee.employee.fileId, source: source }))
    }
    return () => {
      source.cancel('Component got unmounted')
    }
  }, [employees])
  return (
    <div className="manager-page">
      <div className="manager-page__header">
        {photo?.id ? (
          <Image
            width={150}
            height={150}
            preview={false}
            src={`${host}/files${photo?.baseURL}/750x750-${photo?.filePath}`}
          />
        ) : (
          <Image
            width={150}
            height={150}
            preview={false}
            src="error"
            fallback="data:image/png;base64,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"
          />
        )}
        <div className="manager-page__header--right">
          <p className="manager-page__header--doo">
            {t('organization.doo')}: {organization.name}
          </p>
          <p className="manager-page__header--name">
            {t('userRoles.manager')}:{' '}
            {capitalizeName(
              `${user.lastName} ${user.firstName} ${user.middleName}`,
            )}
          </p>
        </div>
      </div>
      <div className="manager-page__nav">
        <div className="manager-page__nav--top">
          <div className="btn">
            <p>{t('organization.organization')}</p>
            <Link to={`/organization/${organization.id}/page`}>
              <img src={Icon1} alt="icon_org" />
            </Link>
          </div>
          <div className="btn">
            <p>{t('employee.title')}</p>
            <Link to={`/organization/${organization.id}/employees`}>
              {' '}
              <img src={Icon2} alt="icon_employees" />
            </Link>
          </div>
          <div className="btn">
            <p>{t('routes.groups')}</p>
            <Link to={`/organization/${organization.id}/groups`}>
              <img src={Icon3} alt="icon_groups" />
            </Link>
          </div>
          <div className="btn">
            <p>{t('pupils.title')}</p>
            <Link to={`/organization/${organization.id}/pupils`}>
              <img src={Icon4} alt="icon_pupil" />
            </Link>
          </div>
          <div className="btn">
            <p>{t('pupils.accept')}</p>
            <Link to={`/organization/${organization.id}/pupils-queue`}>
              <img src={Icon6} alt="icon_queue" />
            </Link>
          </div>
        </div>
        <div className="manager-page__nav--bottom">
          <div className="btn">
            <p>{t('routes.attendance')}</p>
            <img src={Icon9} alt="icon_attendance" />
          </div>
          <div className="btn">
            <p>{t('routes.timesheetShort')}</p>
            <img src={Icon9} alt="icon_attendance" />
          </div>
          <div className="btn">
            <p>{t('routes.menu')}</p>
            <Link to={`/organization/${organization.id}/menu-calendar`}>
              <img src={Icon7} alt="icon_menu" />
            </Link>
          </div>
          <div className="btn">
            <p>{t('routes.manual')}</p>
            <Link to={`/manual`}>
              <img src={Icon5} alt="icon_help" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManagerMainPage
